import jtHelpers from './jobTaskHelpers'

function getCrewNames(route) {
    let members = []
    route.userRoutes.forEach(userRoute => {
        if(userRoute.user.firstName){
            members.push(userRoute.user.firstName)
        }
    })
    return members.join(", ")
}
function getCompletionStatus(route) {
    let completionStatus = true
    route.jobTasks.forEach((jt) => {
        completionStatus = completionStatus && (jt.status === 'Complete')
    })
    return completionStatus
}
function getRandomColour(){
    let letters = "0123456789ABCDEF";
    let color = '#';
    for (let i = 0; i < 6; i++)
        color += letters[(Math.floor(Math.random() * 16))];
    return color
}
function getDisplayTasks(route){
   return jtHelpers.display(route.jobTasks)
}
export default {
    getCrewNames,
    getCompletionStatus,
    getRandomColour,
    getDisplayTasks,
}
